import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import moment from 'moment'
import { get } from 'lodash'
import { centsToDollars } from '../../utils/formatters'

import styles from './OrderRow.module.scss'

const OrderRow = ({ isSelected, refundable, onSelect, order, className }) => {
  const selectedClass = isSelected ? styles.selected : null
  const syncingClass = order.isSyncing ? styles.syncing : null
  const refundableClass = refundable ? styles.refundable : null
  const classNames = cn(styles.orderRow, selectedClass, syncingClass, refundableClass, className)

  const errorClass = order.isDeclined ? styles.paymentFailed : null
  const statusClass = cn(styles.statusCell, errorClass)

  const totalDisplay = (order) => {
    if (order.total) return `$${order.total}`

    const itemModels = get(order, 'itemModels', [])
    let totalInCents = 0

    itemModels.forEach(item => {
      let itemCost = item.priceInCents
      item.modifiers.forEach(modifier => {
        if (modifier.defaultPriceInCents > 0) {
          itemCost += modifier.defaultPriceInCents
        }
      })
      totalInCents += itemCost
    });

    return centsToDollars(totalInCents)
  }

  const timeDisplay = (time) => {
    if (!time) return '-'

    return moment(time).format('h:mm:ss')
  }

  const orderNumber = (order) => get(order, 'orderNumber', '-')

  return (
    <div className={classNames} onClick={() => onSelect(order.uuid)}>
      <div>{orderNumber(order)}</div>
      <div>{timeDisplay(order.submittedAt)}</div>
      <div>{order.isSyncing ? 'syncing' : timeDisplay(order.syncedAt)}</div>
      <div>{totalDisplay(order)}</div>
      <div className={statusClass}/>
    </div>
  )
}

OrderRow.defaultProps = {
  order: {},
}

OrderRow.propTypes = {
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
  order: PropTypes.object,
}

export default OrderRow
